import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const show = window.setTimeout(() => setVisible(true), 5000);
    const hide = window.setTimeout(() => setVisible(false), 15000);
    return () => {
      window.clearTimeout(show);
      window.clearTimeout(hide);
    };
  }, []);
  return <AnimatePresence data-id="element-170" data-mp="21x25kbat0z3c">
      {visible && <motion.aside initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 14
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-4 right-4 z-50 w-[calc(100%-2rem)] max-w-sm rounded-xl border border-accent/25 border-l-4 border-l-accent bg-background/95 p-4 pr-10 text-foreground shadow-2xl shadow-black/50" aria-live="polite" data-id="element-171" data-mp="21yvddtx5lpcx">
          <button type="button" onClick={() => setVisible(false)} className="absolute right-2 top-2 rounded p-1 text-muted transition-colors duration-150 ease-out hover:text-foreground focus:outline-none focus-visible:ring-2 focus-visible:ring-primary" aria-label="Chiudi avviso" data-id="element-172" data-mp="1sg5yrt3pxp6k">
            <XIcon className="h-4 w-4" data-id="element-173" data-mp="1jhkm2ekxh4dp" />
          </button>
          <div className="flex gap-3" data-id="element-174" data-mp="1nfibniim1shm">
            <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-accent" aria-hidden="true" data-id="element-175" data-mp="1ninvojcdu46h" />
            <div data-id="element-176" data-mp="19nlmnnc8nypg">
              <p className="text-[10px] font-extrabold uppercase tracking-[.16em] text-accent" data-id="element-177" data-mp="1efv92te5agmz">Accesso confermato</p>
              <p className="mt-1 text-sm leading-snug text-muted" data-id="element-178" data-mp="zs0e16co006q">
                Una volta completato l&apos;acquisto riceverai la
                <br data-id="element-179" data-mp="14qle95rx2jv6" />
                <span className="font-bold text-foreground" data-id="element-180" data-mp="14nz5j2tahybd">VINO ED ENOLOGIA — Edizione Professionale</span>
              </p>
              <p className="mt-2 text-xs text-muted" data-id="element-181" data-mp="vq5bxzmwtirw">Accesso digitale immediato via email.</p>
            </div>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}